// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".GraphFullscreenBtn-module__btn___fD8NY{min-width:100px}", "",{"version":3,"sources":["webpack://./src/features/cyberlinks/GraphFullscreenBtn/GraphFullscreenBtn.module.scss"],"names":[],"mappings":"AAAA,wCACE,eAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn": "GraphFullscreenBtn-module__btn___fD8NY"
};
export default ___CSS_LOADER_EXPORT___;
